import { Box } from '@mui/material';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import OnboardingSidebar from '../components/OnboardingSidebar';

/**
 * Layout wrapper that conditionally renders onboarding UI based on ?onboarding query param.
 * Audit takes precedence - if both ?audit and ?onboarding are present, audit wins.
 */
export const OnboardingLayoutWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [searchParams] = useSearchParams();
  const onboardingMode = searchParams.has('onboarding');
  const auditMode = searchParams.has('audit');

  // Audit takes precedence
  if (auditMode || !onboardingMode) {
    return <>{children}</>;
  }

  // Onboarding mode: 2-panel layout with sidebar on the right
  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        mr: -10,
      }}
    >
      {/* Center Panel - Main Content */}
      <Box sx={{ flex: 1, overflow: 'auto' }}>{children}</Box>

      {/* Right Panel - Onboarding Checklist */}
      <Box
        sx={{
          width: 400,
          borderLeft: 1,
          ml: 2,
          mr: 3,
          borderColor: 'divider',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.paper',
          borderRadius: 1,
        }}
      >
        <OnboardingSidebar />
      </Box>
    </Box>
  );
};

export default OnboardingLayoutWrapper;
